import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import './assets/styles/main.css';

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);

// 全局错误处理
app.config.errorHandler = (err, instance, info) => {
  console.error('Global error:', err, info);
};

app.mount('#app');
